import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  constructor() {}

  getUserDetails() {}

  isLoggedIn() {
    let dataUser = JSON.parse(localStorage.getItem('user'));
    if (dataUser) {
      if (dataUser.api_key != null && dataUser.authority == 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts